<input type="text" class="form-control mb-2" placeholder="Insert short title here" formControlName="title" />
<hr />
<select class="form-select" formControlName="option">
    <option [ngValue]="CustomFormSignatureType.TARGET_USER">Employee</option>
    <option [ngValue]="CustomFormSignatureType.SUPERVISOR">Supervisor</option>
    <option [ngValue]="CustomFormSignatureType.ADMIN">Administrator</option>
</select>


